var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsoli(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-418 -360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.333 410.667 468.667 417.333 462 410.667 468.667 404 475.333 410.667ZM468.667 390.667 475.733 397.733 484.067 389.4 468.667 374 453.267 389.4 461.6 397.733 468.667 390.667ZM448.667 410.667 455.733 403.6 447.4 395.267 432 410.667 447.4 426.067 455.733 417.733 448.667 410.667ZM488.667 410.667 481.6 417.733 489.933 426.067 505.333 410.667 489.933 395.267 481.6 403.6 488.667 410.667ZM468.667 430.667 461.6 423.6 453.267 431.933 468.667 447.333 484.067 431.933 475.733 423.6 468.667 430.667Z",
    fill: "#FFFFFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsoli);
export default __webpack_public_path__ + "static/media/consoli.a0b08c19eb7f54e6b8475c70bc6646a0.svg";
export { ForwardRef as ReactComponent };